
import { Toast } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Logout extends Vue {
  @Prop({ type: String, default: "" }) public headtitle;
  @Prop({ type: Number, default: 1 }) public typeFn;
  public isIOs = false;

  public mounted() {
    //   url截取token
    // const obj: any = this.$fn.parseQuery(window.location.href);
    if (this.$fn.cookies.getIsios()) {
      this.isIOs = true;
    }
  }
  public onClickLeft() {
    if (this.typeFn == 2) {
      this.$router.go(-1);
    } else {
      this.$fn.onClickLeft();
    }
  }
}
